import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subCategoryServices } from '../services/sub-category.service';

export const useAddSubCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => subCategoryServices.addSubCategory(payload),
    onSuccess: () => {
      queryClient.invalidateQueries(['sub-categories']);
      //   toast.success('Admin created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to add main category');
    },
  });
};
